export const TermsAndConditionsLabel = () => {
  return (
    <label className="custom-control-label" htmlFor="agree">
      I accept{" "}
      <a href="/privacy_policy.html" target="_blank">
        Privacy policy
      </a>{" "}
      and{" "}
      <a href="/terms_of_use.html" target="_blank">
        Terms & Conditions
      </a>
    </label>
  )
}
